import React, { Component } from 'react';
import { Field } from 'redux-form';
import { CommOptionsCheckbox } from './CommOptionsCheckbox';
import { Row, Col } from 'react-bootstrap';

import MdEmail from 'react-icons/lib/md/email';
import MdPhoneIphone from 'react-icons/lib/md/phone-iphone';
import MdLaptopMac from 'react-icons/lib/md/laptop-mac';
import ReactMarkdown from 'react-markdown';
import './CommOptions.scss';

class CommOptions extends Component {
  render() {
    const {
      input: { name },
      content,
      communicationTypes,
      handleCommunicationOptionsChange,
    } = this.props;

    const getIcon = (type) => {
      if (type === 'email') {
        return <MdLaptopMac size={30} />;
      }
      if (type === 'sms') {
        return <MdPhoneIphone size={30} />;
      }
      if (type === 'post') {
        return <MdEmail size={30} />;
      }
    };

    const options = [{ label: ' ', value: true }];
    const colSize = Math.floor(12 / communicationTypes.length);

    return (
      <div className="communications-options">
        <Row>
          {communicationTypes.map((communicationType) => (
            <Col sm={colSize} key={communicationType}>
              <Field
                name={`${name}.${communicationType}`}
                component={CommOptionsCheckbox}
                options={options}
                labelSize={10}
                label={
                  <div className={'communications-label'}>
                    <div>{getIcon(communicationType)}</div>
                    <div>
                      <ReactMarkdown
                        source={content['communication_types'][communicationType]}
                      />
                    </div>
                  </div>
                }
                onChange={(e) =>
                  handleCommunicationOptionsChange(
                    e.currentTarget.checked,
                    communicationType,
                  )
                }
              />
            </Col>
          ))}
        </Row>
      </div>
    );
  }
}

export default CommOptions;
